import { useCallback } from "react";
import me from "models/me";
import { useFetchBrandForMerchant } from "containers/folders/hooks/brands";
import { shouldRetryHookOnError } from "containers/folders/hooks/utils";
import { MAX_FAILURE_COUNT } from "containers/folders/utils/constants";
import { IBrand } from "containers/folders/types/brands";
import { getStore } from "store";
import { activeBrandSet } from "actions/scope";

export const useFetchBrand = (membership?: nuorder.merchant.v1.Member, onBrandFetched?: (brand: IBrand) => void) => {
    const {
        data: brand,
        isFetching: fetchingBrand,
        isIdle: isIdleBrandRequest,
    } = useFetchBrandForMerchant(membership?.merchant_id, false, {
        retry: (failureCount: number, err: any) => {
            if (!shouldRetryHookOnError(err)) {
                return false;
            }
            return failureCount <= MAX_FAILURE_COUNT;
        },
        enabled: !!membership?.merchant_id,
        onError: () => handleBrandFetched(null),
        onSuccess: (it) => handleBrandFetched(it),
    });

    const handleBrandFetched = useCallback(
        (brand) => {
            if (brand && me.isBrandUser()) {
                me.setActiveBrand(brand);
                const store = getStore();
                store.dispatch(activeBrandSet(brand));
            }
            if (onBrandFetched) {
                onBrandFetched(brand);
            }
        },
        [onBrandFetched]
    );

    return {
        brand,
        fetchingBrand,
        isIdleBrandRequest,
    };
};
